import React from 'react'
import { CustomPrice } from 'src/views/components'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

class SubscriptionProductUnitPrice extends React.Component {
  render() {
    const { priceInfo = {}, type = '', isBundle = false } = this.props || {}
    const {
      originalPrice = '',
      priceAfterDiscount = '',
      totalPriceDiscount = 0,
    } = priceInfo || {}
    const priceFreePromotion =
      originalPrice - totalPriceDiscount == priceAfterDiscount &&
      priceAfterDiscount == 0
    const priceTitle = i18nTranslate('cartCreateNewSubscriptionComponent.addToSubscription.priceCaption', 'Price',{ isNextGenTranslations: true })

    return (
      <div
        className="multiple-subscription-price"
        data-testid="qa-subscription-product-price-wrapper">
        <CustomPrice
          custompriceLabel={priceTitle}
          custompriceValue={originalPrice}
          customDiscountPriceValue={priceAfterDiscount}
          isCurrencySymbol={true}
          dataTestId="qa-multiple-subscription-price"
          priceFreePromotion={priceFreePromotion}
          type={type}
          isbundle={isBundle}
          isToShowNewPriceStyling={true}
        />
      </div>
    )
  }
}

export default SubscriptionProductUnitPrice
export { SubscriptionProductUnitPrice }
